import React, { FC } from 'react';
import { FormGroup, Input, Label } from 'reactstrap';

import { formatISODate } from '../../helpers/formatISODate';
import useTranslate from '../../hooks/useTranslate';
import DateRangePicker, { DateRangePickerProps } from '../DateRangePicker/DateRangePicker';

const AccommodationDatesPicker: FC<Omit<DateRangePickerProps, 'selectsRange'>> = props => {
  const { startDate, endDate } = props;
  const { translate } = useTranslate();

  return (
    <>
      <DateRangePicker selected={startDate} minDate={new Date()} {...props} />
      <div className="mt-3 d-flex gap-3 justify-content-center">
        {[
          { value: startDate, label: String(translate('accommodation.checkIn')) },
          { value: endDate, label: String(translate('accommodation.checkOut')) },
        ].map(({ value, label }, index) => (
          <FormGroup
            key={`accommodation-date-${index + 1}`}
            className="d-inline-block"
            floating
            style={{ marginBottom: '0 !important' }}
          >
            <Input
              id={`accommodation-date-${index}`}
              name={`accommodation-date-${index}`}
              placeholder={label}
              type="text"
              readOnly
              disabled
              style={{ backgroundColor: 'white' }}
              value={value ? formatISODate(value) : ''}
            />
            <Label for={`accommodation-date-${index}`} className="mt-0">
              {label}
            </Label>
          </FormGroup>
        ))}
      </div>
    </>
  );
};

export default AccommodationDatesPicker;
